// extracted by mini-css-extract-plugin
export var artDirected = "styles-module--art-directed--4a1a4";
export var author = "styles-module--author--0054b";
export var children = "styles-module--children--9c01b";
export var gradient = "styles-module--gradient--b06eb";
export var line = "styles-module--line--9d377";
export var quote = "styles-module--quote--dd626";
export var subhead = "styles-module--subhead--f1e6b";
export var text = "styles-module--text--8c633";
export var title = "styles-module--title--76ce9";